import React, { useState } from "react";
import { useAuth } from "context/AuthContext";
import EcoSaltUpgradesPanel from "pages/ecosaltUpgrade/EcoSaltUpgradesPanel";
import { ViewTab, ViewTabs } from "styles/ecosaltUpgrade.styles";

type EcoSaltView = "dashboard" | "update";

/** Admins switch between the upgrade list and the Nipper update screen. */
function EcoSaltViewTabs({
  update,
  onDeleted,
}: {
  update: React.ReactNode;
  onDeleted?: (serial: string) => void;
}) {
  const { user } = useAuth();
  const isAdmin = user?.role === "ADMIN";
  const [view, setView] = useState<EcoSaltView>("dashboard");

  if (!isAdmin) return <>{update}</>;

  return (
    <>
      <ViewTabs role="tablist" aria-label="EcoSalt views">
        <ViewTab type="button" role="tab" aria-selected={view === "dashboard"} $active={view === "dashboard"} onClick={() => setView("dashboard")}>
          Dashboard
        </ViewTab>
        <ViewTab type="button" role="tab" aria-selected={view === "update"} $active={view === "update"} onClick={() => setView("update")}>
          Update
        </ViewTab>
      </ViewTabs>
      {view === "dashboard" ? <EcoSaltUpgradesPanel onDeleted={onDeleted} /> : update}
    </>
  );
}

export default EcoSaltViewTabs;
